import { render, staticRenderFns } from "./DocCateAdd.vue?vue&type=template&id=73ab7cc3&scoped=true"
import script from "./DocCateAdd.vue?vue&type=script&lang=js"
export * from "./DocCateAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ab7cc3",
  null
  
)

export default component.exports